/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Lens_AllInputs */

const en_lens_all = /** @type {(inputs: Lens_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All brands`)
};

/**
* | output |
* | --- |
* | "All brands" |
*
* @param {Lens_AllInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const lens_all = /** @type {((inputs?: Lens_AllInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Lens_AllInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_lens_all(inputs)
});